import React, {Component} from 'react';
import './App.css';
import {GameList} from './Components/GameList.js';
import SelectionComps from './Components/SelectionComps.js';
import Settings from './Components/Settings.js';
import { Button } from '@material-ui/core';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      filters: {
        genres: "all",
        players: "allPlayerTypes",
        maturity: "allAges"
      },
      settings: {
        tableToggle: false,
        scrollToggle: true,
        hideSettings: false,
        selectionsToggle: true
      },
      sort: "alpha",
      secret: false,
      table: {
        cols: "Default"
      }
    }
    this.onFilterChange = this.onFilterChange.bind(this);
    this.onSettingsChange = this.onSettingsChange.bind(this);
    this.onDisplaySortChange = this.onDisplaySortChange.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.onSecretSelected = this.onSecretSelected.bind(this);
  }

  onFilterChange(e) {
    this.setState({filters: e});
  }

  onSettingsChange(e) {
    this.setState({settings: e});
  }

  onDisplaySortChange(e) {
    this.setState({sort: e});
  }

  onTableChange(e) {
    this.setState({table: e});
  }

  onSecretSelected() {
    this.setState({secret: !this.state.secret});
  }


  render() {
    const isIFrame = window.self !== window.top;
    if (isIFrame) {
      document.body.style.overflow = "none";
    }

    let settingsBtns = (isIFrame)? 
      null : 
      <Settings 
        options = {this.state.settings}
        onSettingsChange = {this.onSettingsChange} />;
    let selectionBtns = (this.state.settings.selectionsToggle)? 
      <SelectionComps 
        options = {this.state.settings}
        filterList = {this.state.filters}
        onFilterChange = {this.onFilterChange}
        sortAlgo = {this.state.sort}
        onSortChange = {this.onDisplaySortChange}
        tableList = {this.state.table}
        onTableChange = {this.onTableChange}
        /> :
        null;
    
    //check for settings toggle
    settingsBtns = (this.state.settings.hideSettings)? null : settingsBtns;

    return (
      <div>
        <div>
          {selectionBtns}
        </div>
        <div>
          <GameList 
          filters = {this.state.filters}
          settings = {this.state.settings}
          tableFormat = {this.state.table}
          sortOption = {this.state.sort}
          matchFunc = {this.props.match}
          secretVisible = {this.state.secret}
          />
        </div>
        <div className="leaderboardsTextWrapper">
          <Button 
              className="button"
              href="https://www.ctrlv.ca/leaderboards" >
              <span className="button-text"> Game Leaderboards </span>
          </Button>
          <Button 
              className="button"
              onClick={this.onSecretSelected} >
              <span className="button-text"> {this.state.secret ? "Hide Secret Games" : "Show Secret Games"} </span>
          </Button>
        </div>
        <div>
          {settingsBtns}
        </div>
      </div>
    );
  }
}

export default App;
